var MemberList = require('memberlist');


var MemberOwnerList = MemberList.extend({
    modeCategory: 'OWNER'
});


module.exports = MemberOwnerList;



//////////////////
// WEBPACK FOOTER
// ./app/src/collection/memberownerlist.js
// module id = dFhQ
// module chunks = 1